import { GETConfig, POSTConfig } from "@/types/common.types";
import {
	AddPlatformParams,
	Platform,
	UpdatePlatformParams,
} from "@/types/platform.types";
import axios from "axios";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const addPlatform = async (
	accessToken: string,
	params: AddPlatformParams
) => {
	const formData = new FormData();

	formData.append("platformname", params.platformname);
	formData.append("logo", params.attachment);

	const response = await axios.post(
		`${server_url}case/addplatforms`,
		formData,
		POSTConfig(accessToken)
	);

	return response.data;
};

export const updatePlatform = async (
	accessToken: string,
	params: UpdatePlatformParams
) => {
	const response = await axios.post(
		`${server_url}case/updateplatform`,
		params,
		POSTConfig(accessToken)
	);
	return response.data;
};

export const getPlatforms = async (
	accessToken: string
): Promise<Platform[]> => {
	const res = await axios.get(
		`${server_url}case/getplatforms`,
		GETConfig(accessToken)
	);
	return res.data;
};

export const getSinglePlatform = async (
	Platformid: number,
	accessToken: string
): Promise<Platform> => {
	const res = await axios.get(
		`${server_url}case/getsingleplatform/${Platformid}`,
		GETConfig(accessToken)
	);
	return res.data[0];
};
